/*
 * Toast Actions
 *
 * @version 1.0.0
 * @author Tommaso Frazzetto
 * @since 18-Sep-2024
 */

import { createAction } from './index'

export const actionTypes = {
  // @generator action:type
  DO_SHOW_TOAST: '@@toast/show_toast',
  DO_HIDE_TOAST: '@@toast/hide_toast'
}

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:request
// @generator action

/** @action
* * Insert a description
* @name doHideToast
* @return {object} - The payload object
*/
export const doHideToast = payload => createAction(actionTypes.DO_HIDE_TOAST, { payload })

/** @action
* * Insert a description
* @name doShowToast
* @return {object} - The payload object
*/
export const doShowToast = (key, moreInfo, id = crypto.randomUUID()) => createAction(actionTypes.DO_SHOW_TOAST, { key, moreInfo, id })
